import { type FC, memo } from 'react'

import ZoomIn from 'features/Home/assets/zoom-in.svg'
import ZoomOut from 'features/Home/assets/zoom-out.svg'

import styles from './zoomControls.module.scss'

export const ZoomControls: FC<{
  onZoomIn: () => void
  onZoomOut: () => void
}> = memo(({ onZoomIn, onZoomOut }) => {
  return (
    <div className={styles.parent}>
      <button type='button' onClick={onZoomOut} className='center'>
        <img className={styles.zoomImg} src={ZoomOut} alt='Zoom out' />
      </button>
      <button type='button' onClick={onZoomIn} className='center'>
        <img className={styles.zoomImg} src={ZoomIn} alt='Zoom in' />
      </button>
    </div>
  )
})
